import { createContext, useContext } from "react";

export const IsRtlContext = createContext<boolean>(false);

export const useIsRtl = () => useContext(IsRtlContext);
